import axiosInstance, { getErrorMessage } from './axiosInstance';
import API_CONFIG from '../config/api';

export const campaignApi = {
  list: async (params = {}) => {
    try {
      const response = await axiosInstance.get(API_CONFIG.ENDPOINTS.CLIENT_CAMPAIGNS, { params });
      return response.data;
    } catch (error) {
      throw new Error(getErrorMessage(error));
    }
  },

  create: async (payload, config = {}) => {
    try {
      const response = await axiosInstance.post(API_CONFIG.ENDPOINTS.CLIENT_CAMPAIGNS, payload, config);
      return response.data;
    } catch (error) {
      throw new Error(getErrorMessage(error));
    }
  },

  getRecipients: async (campaignId, params = {}) => {
    try {
      const response = await axiosInstance.get(API_CONFIG.ENDPOINTS.CLIENT_CAMPAIGN_RECIPIENTS(campaignId), { params });
      return response.data;
    } catch (error) {
      throw new Error(getErrorMessage(error));
    }
  },

  runNow: async (campaignId) => {
    try {
      const response = await axiosInstance.post(API_CONFIG.ENDPOINTS.CLIENT_CAMPAIGN_RUN_NOW(campaignId));
      return response.data;
    } catch (error) {
      throw new Error(getErrorMessage(error));
    }
  },

  retryFailed: async (campaignId) => {
    try {
      const response = await axiosInstance.post(API_CONFIG.ENDPOINTS.CLIENT_CAMPAIGN_RETRY_FAILED(campaignId));
      return response.data;
    } catch (error) {
      throw new Error(getErrorMessage(error));
    }
  },
};

export default campaignApi;
